import { withData } from './base-composer';

/**
 * Availability composer function
 * @param state
 */
export const Company = state => {
  return Object.assign(
    {},
    state,
    // composers
    withData()
  );
};
